import axios from 'axios';
import { isQueueablePath, isNetworkError, enqueue, flushQueue, queueLength } from './offlineQueue';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(config => {
  const token = sessionStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      sessionStorage.removeItem('token');
      window.location.href = '/login';
      return Promise.reject(err);
    }

    // Score save/clear while offline: queue it locally and resolve as "queued"
    // instead of failing, so the calling page doesn't need special-case error handling.
    if (err.config && (err.config.method || '').toLowerCase() === 'post'
        && isQueueablePath(err.config.url) && isNetworkError(err)) {
      let body = {};
      try { body = JSON.parse(err.config.data || '{}'); } catch { /* leave as {} */ }
      enqueue(err.config.url, err.config.method, body);
      return Promise.resolve({ data: { queued: true }, status: 0, statusText: 'Queued offline', headers: {}, config: err.config });
    }

    return Promise.reject(err);
  }
);

const tryFlush = () => { if (queueLength() > 0) flushQueue(api); };
window.addEventListener('online', tryFlush);
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') tryFlush();
});
setInterval(tryFlush, 45000);

export default api;
